import { render } from "./blog-comments.vue?vue&type=template&id=2c88d1b1"
import script from "./blog-comments.vue?vue&type=script&lang=js"
export * from "./blog-comments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__